import { callPostApi, callDeleteApi, callPutApi, callGetApi } from "./api";

export async function getCmsPagesList(data) {
      try {
            const response = await callPostApi({ url: "page", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getCmsPagesDetail(pageId) {
      try {
            const response = await callGetApi({ url: "page/" + pageId });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function createCmsPages(postData) {
      try {
            const response = await callPostApi({ url: "page/add", body: postData });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function updateCmsPages(postData, pageId) {
      try {
            const response = await callPutApi({ url: "page/" + pageId, body: postData });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function deleteCmsPage(id) {
      try {
            const response = await callDeleteApi({ url: "page/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}


